import { Expensable } from 'modules/expenses/types/Expensable'

interface ReturnedData {
  cost_centers:
    | {
        allocation?: {
          id: string
          referenceId: string
          referenceType: string
        }
        assignments?: {
          assignmentsToCreate: {
            costCenterId: string
            percentage: number
            startDate: string
            endDate: string
          }[]
          assignmentsToUpdate: {
            id: string
            costCenterId: string
            percentage: number
            startDate: string
            endDate: string
            markedForDeletion: boolean
          }[]
        }
      }
    | undefined
}

export const getCostCenterDefaultValues = (expensable?: Expensable): ReturnedData => {
  const data = expensable?.costCenterDistribution

  if (!data || data.length === 0) {
    return {
      cost_centers: undefined,
    }
  }

  if (data[0]?.allocationId) {
    return {
      cost_centers: {
        allocation: {
          id: data[0].allocationId,
          referenceId: String(data[0].allocationReferenceId),
          referenceType: String(data[0].allocationReferenceType),
        },
      },
    }
  } else if (data[0]?.assignmentId) {
    return {
      cost_centers: {
        assignments: {
          assignmentsToCreate: [],
          assignmentsToUpdate: data.map((assignment) => ({
            id: String(assignment.assignmentId),
            costCenterId: assignment.costCenter.id,
            percentage: assignment.percentage,
            startDate: expensable?.effectiveOn,
            markedForDeletion: false,
            endDate: expensable?.effectiveOn,
          })),
        },
      },
    }
  }

  return {
    cost_centers: undefined,
  }
}
